import * as CalculatorStepTracker from "@omni/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@omni/services/tracking/trackers/tools/calculators/config";
import { parseFloatSafe } from "@omni/utils/number.utils";
import queryString from "query-string";
import { PureComponent } from "react";

import { asyncState } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

type RoofingCalculatorState = {
    roofLength: string;
    roofWidth: string;
    roofArea: number;
};

class RoofingCalculator extends PureComponent<{}, RoofingCalculatorState> {
    query = queryString.parse(location.search);

    constructor(props: {}) {
        super(props);
        this.state = {
            roofLength: this.query.roofLength?.toString() || "0",
            roofWidth: this.query.roofWidth?.toString() || "0",
            roofArea: 0
        };
    }

    async componentDidMount() {
        await asyncState(this, {
            roofArea: this.roofArea()
        });

        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.roofing);
    }

    roofArea = () => {
        return (
            parseFloatSafe(this.state.roofLength, 0) *
            parseFloatSafe(this.state.roofWidth, 0)
        );
    };

    setCalculationValue = (field: string, value: string) => {
        this.setState(
            (state) => ({ ...state, [field]: value }),
            () => {
                this.setState({ roofArea: this.roofArea() });

                CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.roofing);
            }
        );
    };

    render() {
        const calculationProps = {
            setCalculationValue: this.setCalculationValue,
            roofLength: this.state.roofLength,
            roofWidth: this.state.roofWidth
        };
        const resultProps = {
            roofArea: this.state.roofArea,
            mailParams: {
                roofLength: this.state.roofLength,
                roofWidth: this.state.roofWidth
            }
        };

        return (
            <div id="calculator">
                <Calculation {...calculationProps} />
                <Result {...resultProps} />
            </div>
        );
    }
}

export { RoofingCalculator };
